const productionRouter = [
  // 产品能力看板
  {
    path: 'product-capability',
    name: 'ProfitBoardContent',
    component: () => import('@/views/wxapp/bulletin-board/profit-board-content'),
    meta: {
      title: '集团'
    },
    children: [
      {
        path: 'product-capability-home',
        name: 'ProductCapability',
        component: () => import('@/views/wxapp/bulletin-board/profit-board-content/product-capability/home'),
        meta: {
          title: '集团'
        }
      },
      {
        path: 'department-gross-analysis',
        name: 'DepartmentGrossAnalysis',
        component: () => import('@/views/wxapp/bulletin-board/profit-board-content/product-capability/department-gross-analysis'),
        meta: {
          title: '集团'
        }
      },
      {
        path: 'fail-order',
        name: 'FailOrderRank',
        component: () => import('@/views/wxapp/bulletin-board/profit-board-content/product-capability/fail-order/FailOrderRank'),
        meta: {
          title: '输单'
        }
      },
      {
        path: 'fail-order-user',
        name: 'failOrdeUser',
        component: () => import('@/views/wxapp/bulletin-board/profit-board-content/product-capability/fail-order/failOrdeUser'),
        meta: {
          title: '输单'
        }
      },
      {
        path: 'service-board',
        name: 'ServiceBoard',
        component: () => import('@/views/wxapp/bulletin-board/service-board'),
        meta: {
          title: ''
        }
      }
    ]
  }

]
export default productionRouter

